'use client';
import { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';
import { iconButtonClasses } from '@mui/material/IconButton';

import { useBoolean } from 'src/hooks/use-boolean';

import { SplashScreen } from 'src/components/loading-screen/splash-screen.jsx';
import { allLangs } from 'src/locales';
import { _contacts, _notifications } from 'src/_mock';

import { Logo } from 'src/components/logo';
import { useSettingsContext } from 'src/components/settings';

import { Main } from './main';
import { NavMobile } from './nav-mobile';
import { layoutClasses } from '../classes';
import { NavVertical } from './nav-vertical';
import { NavHorizontal } from './nav-horizontal';
import { _account } from '../config-nav-account';
import { Searchbar } from '../components/searchbar';
import { _workspaces } from '../config-nav-workspace';
import { MenuButton } from '../components/menu-button';
import { View403 } from 'src/sections/error/403-view.jsx';

import { LayoutSection } from '../core/layout-section';
import { DashboardHeader as HeaderSection } from './dashboard-header';
import { TopNavigation } from './top-navigation';
import { StyledDivider, useNavColorVars } from './styles';
import { AccountDrawer } from '../components/account-drawer';
import { SettingsButton } from '../components/settings-button';
import { LanguagePopover } from '../components/language-popover';
import { ContactsPopover } from '../components/contacts-popover';
import { WorkspacesPopover } from '../components/workspaces-popover';
import { navData as dashboardNavData } from '../config-nav-dashboard';
import {
  forRestrictedNavsnavData as RouteNavData,
  manualnonrestrictedpaths,
} from '../config-nav-dashboard';
import { NotificationsDrawer } from '../components/notifications-drawer';
import { MainAppOption, _mainAppOptions } from '../components/main-app-option';
import { useGetCompanyInfo } from 'src/actions/setup/setupActions.ts';

import { useGetClientDetails } from 'src/actions/setup/setupActions';

import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import Button from '@mui/material/Button';

import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import Link from '@mui/material/Link';
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
import { usePathname, useRouter } from 'next/navigation';

import { useAuthContext } from 'src/auth/hooks';
import { requestPermission, onMessageListener } from 'src/lib/firebase';

// ----------------------------------------------------------------------

export function cleanKey(key) {
  return key?.toLowerCase().trim().replace(/\s+/g, ''); // Trim, convert to lowercase, and remove spaces
}
const isEnabled = (tairraUser, item) => {
  if (tairraUser?.isExternalEmployee) {
    let isInternalModules = [2, 4, 7, 8, 10, 11, 12, 13].includes(item.id);
    // let isInternalModules = [1].includes(item.id);
    if (isInternalModules) {
      return false;
    }
  }

  if (item.id == 12) {
    let hasSettingPermission = tairraUser?.userRights?.filter(
      (r) => r.moduleName == 'System' && r.name == 'EditSystemSettings'
    );
    if (hasSettingPermission?.length == 0) {
      return false;
    }
  }
  return true;
};

export function DashboardLayout({ sx, children, header, data }) {
  // useEffect(() => {
  //   requestPermission();
  //   onMessageListener()
  //     .then((payload) => {
  //       console.log('message received:', payload);
  //     })
  //     .catch((err) => console.error('FCM Listener Error:', err));
  // }, []);

  const { t } = useTranslation('navbar');

  const { tairraUser } = useAuthContext();
  const router = useRouter();
  const pathname = usePathname();
  const { companyInfo, companyInfoLoading, companyInfoError, mutateCompanyInfo } =
    useGetCompanyInfo();
  const { clientDetail, clientDetailLoading, mutateClientDetail } = useGetClientDetails(1);
  const [restrictedPathUse, setRestrictedexternaluse] = useState(false);
  const theme = useTheme();

  const mobileNavOpen = useBoolean();

  const settings = useSettingsContext();

  const navColorVars = useNavColorVars(theme, settings);

  const layoutQuery = 'lg';

  const navData = (data?.nav ?? dashboardNavData).map((section) => ({
    ...section,
    subheader: t(cleanKey(section.subheader)),
    items: (section.items || [])
      .filter((item) => isEnabled(tairraUser, item))
      .map((item) => ({
        ...item,
        title: t(cleanKey(item.title)),
      })),
  }));
  const isNavMini = false;
  const isNavHorizontal = true;
  const isNavVertical = false;
  const [qrCodeData, setQrCodeData] = useState('');
  const [qrCodeImage, setQrCodeImage] = useState('');

  useEffect(() => {
    if (clientDetail?.tenant?.license) {
      setQrCodeData(clientDetail.tenant.license);
      QRCode.toDataURL(clientDetail.tenant.license)
        .then((url) => setQrCodeImage(url))
        .catch((err) => console.error(err));
    }
  }, [clientDetail]);

  const [openCompanyIfo, setOpenCompanyInfo] = useState(false);

  const handleOpenCompanyInfo = () => {
    setOpenCompanyInfo(true);
  };

  const handleCloseCompanyInfo = () => {
    setOpenCompanyInfo(false);
  };

  const [ClientData, setClientData] = useState();

  useEffect(() => {
    if (companyInfo) {
      setClientData(companyInfo);
    }
  }, [companyInfo]);
  // const restrictedModuleIds = [2, 4, 7, 8, 10, 11, 12, 13];
  const restrictedModuleIds = [1, 3, 5, 6, 9];
  useEffect(() => {
    if (tairraUser?.isExternalEmployee) {
      let restrictedPaths = RouteNavData.flatMap((section) => section.items)
        .filter((item) => restrictedModuleIds.includes(item.id))
        .map((item) => item.path);

      restrictedPaths = [...manualnonrestrictedpaths, ...restrictedPaths];
      let updatepath = pathname.replace(/\/$/, '');
      const pathSegments = updatepath.split('/');
      if (!isNaN(Number(pathSegments[pathSegments.length - 1]))) {
        pathSegments.pop(); // Remove last segment if it's a number
      }
      const cleanPathname = pathSegments.join('/');

      if (`${restrictedPaths}/`.includes(cleanPathname)) {
        setRestrictedexternaluse(false);
      } else {
        setRestrictedexternaluse(true);
      }
    } else {
      setRestrictedexternaluse(false);
    }
    const hasEditSystemSettings =
      tairraUser?.userRights?.some(
        (r) => r.moduleName === 'System' && r.name === 'EditSystemSettings'
      ) || false;

    if (!hasEditSystemSettings && pathname === '/dashboard/product/') {
      setRestrictedexternaluse(true);
    }
  }, [tairraUser, pathname]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'authLogout') {
        window.location.href = '/auth/jwt/sign-in';
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  return (
    <>
      {' '}
      {tairraUser ? (
        <LayoutSection
          /** **************************************
           * Header
           *************************************** */
          headerSection={
            <HeaderSection
              layoutQuery={layoutQuery}
              disableElevation={isNavVertical}
              slotProps={{
                toolbar: {
                  sx: {
                    ...(isNavHorizontal && {
                      bgcolor: 'var(--layout-nav-bg)',
                      [`& .${iconButtonClasses.root}`]: {
                        color: 'var(--layout-nav-text-secondary-color)',
                      },
                      [theme.breakpoints.up(layoutQuery)]: {
                        height: 'var(--layout-nav-horizontal-height)',
                      },
                      pb: 8,
                      pt: 3,
                    }),
                  },
                },
                container: {
                  maxWidth: false,
                  sx: {
                    ...(isNavVertical && { px: { [layoutQuery]: 5 } }),
                    pt: '2em',
                  },
                },
              }}
              sx={header?.sx}
              slots={{
                topArea: (
                  <Alert severity="info" sx={{ display: 'none', borderRadius: 0 }}>
                    This is an info Alert.
                  </Alert>
                ),
                bottomArea: isNavHorizontal ? (
                  <NavHorizontal
                    data={navData}
                    layoutQuery={layoutQuery}
                    cssVars={navColorVars.section}
                  />
                ) : null,
                leftArea: (
                  <>
                    <MenuButton
                      onClick={mobileNavOpen.onTrue}
                      sx={{
                        mr: 1,
                        ml: -1,
                        [theme.breakpoints.up(layoutQuery)]: { display: 'none' },
                      }}
                    />
                    <NavMobile
                      data={navData}
                      open={mobileNavOpen.value}
                      onClose={mobileNavOpen.onFalse}
                      cssVars={navColorVars.section}
                    />

                    {/* {isNavHorizontal && (
                      <Logo
                        sx={{
                          display: 'none',
                          [theme.breakpoints.up(layoutQuery)]: {
                            display: 'inline-flex',
                          },
                        }}
                      />
                    )} */}

                    {/* {isNavHorizontal && (
                      <StyledDivider
                        sx={{
                          [theme.breakpoints.up(layoutQuery)]: { display: 'flex' },
                        }}
                      />
                    )} */}

                    <Avatar
                      alt={ClientData?.organizationName}
                      src={ClientData?.logoUrl}
                      sx={{
                        width: 70,
                        height: 50,
                        borderRadius: ClientData?.logoUrl ? 0 : '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={handleOpenCompanyInfo}
                      imgProps={{
                        style: { objectFit: 'contain' },
                      }}
                    >
                      {!ClientData?.logoUrl &&
                        ClientData?.organizationName?.charAt(0).toUpperCase()}
                    </Avatar>

                    <Typography
                      onClick={handleOpenCompanyInfo}
                      sx={{ ml: 1, cursor: 'pointer', fontSize: 13 }}
                      variant="subtitle1"
                    >
                      {ClientData?.organizationName}
                    </Typography>

                    <Dialog
                      open={openCompanyIfo}
                      onClose={handleCloseCompanyInfo}
                      fullWidth
                      maxWidth="sm"
                      sx={{ padding: 3 }}
                    >
                      <DialogTitle sx={{ padding: '16px 24px' }} variant="subtitle1">
                        {' '}
                        {t('companyInfo')}
                      </DialogTitle>

                      <DialogContent sx={{ padding: 3 }}>
                        <Box
                          sx={{
                            mb: 4,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                          }}
                        >
                          <Avatar
                            sx={{
                              cursor: 'pointer',
                              width: '50%',
                              height: 'auto',
                              borderRadius: 0,
                              '& img': {
                                objectFit: 'cover',
                              },
                              mb: 3,
                            }}
                            src={ClientData?.logoUrl || 'default-avatar-url'}
                          />
                          <Typography
                            variant="body2"
                            sx={{ textAlign: 'center', fontWeight: 'bold' }}
                          >
                            {ClientData?.organizationName || 'Company Name Not Available'}
                          </Typography>
                        </Box>

                        {/* Company Info */}
                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ ml: 2 }} variant="body2">
                            <strong>{t('companyName')}:</strong>{' '}
                            {ClientData?.organizationName || 'Not Available'}
                          </Typography>
                        </Box>

                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ ml: 2 }} variant="body2">
                            <strong>{t('companyEmail')}:</strong>{' '}
                            {ClientData?.email || 'Not Available'}
                          </Typography>
                        </Box>

                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ ml: 2 }} variant="body2">
                            <strong>{t('contactNumber')}:</strong>{' '}
                            {ClientData?.mobileNumber || 'Not Available'}
                          </Typography>
                        </Box>

                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ ml: 2 }} variant="body2">
                            <strong>{t('website')}:</strong>{' '}
                            {ClientData?.website || 'Not Available'}
                          </Typography>
                        </Box>

                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ ml: 2 }} variant="body2">
                            <strong>{t('license')}:</strong>{' '}
                            {clientDetail?.tenant?.license || 'Not Available'}
                          </Typography>
                        </Box>

                        <Box sx={{ mb: 2, ml: 1 }}>
                          {qrCodeImage ? (
                            <img
                              src={qrCodeImage}
                              alt="QR Code"
                              style={{ maxWidth: '100px', maxHeight: '100px' }}
                            />
                          ) : (
                            <Typography variant="body2">QR Code not available</Typography>
                          )}
                        </Box>
                      </DialogContent>

                      <DialogActions>
                        <Button
                          onClick={handleCloseCompanyInfo}
                          color="inherit"
                          variant="contained"
                        >
                          {t('close')}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </>
                ),
                centerArea: <TopNavigation data={navData} />,
                rightArea: (
                  <Box display="flex" alignItems="center" gap={{ xs: 0.5, sm: 1 }}>
                    {/* <Searchbar data={navData} /> */}
                    {/* <MainAppOption
                  data={_mainAppOptions[0]}
                  sx={{ color: 'var(--layout-nav-text-primary-color)' }}
                />

                <MainAppOption
                  data={_mainAppOptions[1]}
                  sx={{ color: 'var(--layout-nav-text-primary-color)' }}
                />

                <MainAppOption
                  data={_mainAppOptions[2]}
                  sx={{ color: 'var(--layout-nav-text-primary-color)' }}
                />

                <MainAppOption
                  data={_mainAppOptions[3]}
                  sx={{ color: 'var(--layout-nav-text-primary-color)' }}
                /> */}

                    {/* -- Searchbar -- */}
                    {/* -- Language popover -- */}
                    {/* -- Notifications popover -- */}
                    {/*  <NotificationsDrawer data={_notifications} /> */}
                    {/* -- Contacts popover -- */}
                    <ContactsPopover data={_contacts} />
                    <LanguagePopover data={allLangs} />

                    {/* -- Settings button -- */}

                    {/* <SettingsButton /> */}

                    {/* <Link
                    href={paths.faqs}
                    component={RouterLink}
                    color="inherit"
                    sx={{ typography: 'subtitle2' }}
                  >
                    Need help?
                  </Link> */}

                    {/* -- Account drawer -- */}
                    <AccountDrawer data={_account} />
                  </Box>
                ),
              }}
            />
          }
          /** **************************************
           * Sidebar
           *************************************** */
          sidebarSection={
            isNavHorizontal ? null : (
              <NavVertical
                data={navData}
                isNavMini={isNavMini}
                layoutQuery={layoutQuery}
                cssVars={navColorVars.section}
                onToggleNav={() =>
                  settings.onUpdateField(
                    'navLayout',
                    settings.navLayout === 'vertical' ? 'mini' : 'vertical'
                  )
                }
              />
            )
          }
          /** **************************************
           * Footer
           *************************************** */
          footerSection={null}
          /** **************************************
           * Style
           *************************************** */
          cssVars={{
            ...navColorVars.layout,
            '--layout-transition-easing': 'linear',
            '--layout-transition-duration': '120ms',
            '--layout-nav-mini-width': '88px',
            '--layout-nav-vertical-width': '300px',
            '--layout-nav-horizontal-height': '64px',
            '--layout-dashboard-content-pt': theme.spacing(1),
            '--layout-dashboard-content-pb': theme.spacing(8),
            '--layout-dashboard-content-px': theme.spacing(5),
          }}
          sx={{
            [`& .${layoutClasses.hasSidebar}`]: {
              [theme.breakpoints.up(layoutQuery)]: {
                transition: theme.transitions.create(['padding-left'], {
                  easing: 'var(--layout-transition-easing)',
                  duration: 'var(--layout-transition-duration)',
                }),
                pl: isNavMini ? 'var(--layout-nav-mini-width)' : 'var(--layout-nav-vertical-width)',
              },
            },
            ...sx,
          }}
        >
          <Main isNavHorizontal={isNavHorizontal}>
            {restrictedPathUse ? (
              <View403 sx={{ pt: '2em' }} fullPage={false} />
            ) : (
              <div style={{ paddingTop: !isNavHorizontal ? '2em' : '0' }}>{children}</div>
            )}
          </Main>
        </LayoutSection>
      ) : (
        <SplashScreen />
      )}
    </>
  );
}
